import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Practice } from '../models/practice';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PracticeService {
  API_URL = `${environment.apiUrl}/practices`;

  constructor(private http: HttpClient) {}

  getPractices(): Observable<Practice[]> {
    return this.http.get<Practice[]>(this.API_URL).pipe(
      map(practices => practices.sort((a, b) => {
          const dateA = a.modifiedDate ? new Date(a.modifiedDate).getTime() : 0;
          const dateB = b.modifiedDate ? new Date(b.modifiedDate).getTime() : 0;
          if (dateB !== dateA) {
            return dateB - dateA;
          }
          return (b.id ?? 0) - (a.id ?? 0);
        }))
      );
  }

  getById(id: number): Observable<Practice> {
    return this.http.get<Practice>(`${this.API_URL}/${id}`);
  }

  create(practice: Practice): Observable<Practice> {
    return this.http.post<Practice>(this.API_URL, practice);
  }

  update(practice: Practice): Observable<Practice> {
    return this.http.put<Practice>(`${this.API_URL}/${practice.id}`, practice);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }

  addPractice(practice: Practice): Observable<Practice> {
    return this.create(practice);
  }

  updatePractice(practice: Practice): Observable<Practice> {
    return this.update(practice);
  }

  deletePractice(id: number): Observable<void> {
    return this.delete(id);
  }
}
